import React from 'react';

const LandingPage = () => {
    return (
        <div 
            className="
                relative 
                min-h-[80vh]      /* mobile */
                sm:min-h-[90vh]   /* small tablets */
                md:min-h-screen   /* desktop */
                flex items-center justify-center 
                overflow-hidden bg-black
            "
            >
            {/* Dark gradient background */}
            <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black opacity-90"></div>

            {/* Pattern overlay */}
            <div className="absolute inset-0 opacity-5">
                <div
                className="w-full h-full"
                style={{
                    backgroundImage: `radial-gradient(circle at 30px 30px, white 2px, transparent 2px)`,
                    backgroundSize: '60px 60px',
                }}
                ></div>
            </div>

            {/* Main Content */}
            <div className="relative z-10 text-center max-w-6xl mx-auto px-6 sm:py-10 md:py-20">
                <p className="text-[8px] sm:text-[9px] md:text-[10px] tracking-[0.3em] uppercase text-gray-400 mb-6 sm:mb-8">
                For Enterprises • Professionals • Business Owners
                </p>

                <h1 className="text-4xl sm:text-5xl lg:text-6xl 2xl:text-7xl font-thin tracking-tight leading-none mb-4 sm:mb-6">
                BOOST
                </h1>

                <h1 className="text-4xl sm:text-5xl lg:text-6xl 2xl:text-7xl font-thin tracking-tight leading-none mb-6 sm:mb-8 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
                PRODUCTIVITY
                </h1>

                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-thin tracking-wide text-gray-300 mb-6 sm:mb-8">
                Scale with <em>AI</em>
                </h2>

                <div className="w-px h-12 sm:h-16 bg-gradient-to-b from-transparent via-white to-transparent mx-auto mb-6 sm:mb-8"></div>

                <p className="text-base sm:text-lg md:text-xl font-light leading-relaxed max-w-4xl mx-auto tracking-wide text-gray-100">
                Upskill your team with hands-on AI training or unlock enterprise-wide impact with custom implementation.
                <em className="text-gray-400"> Designed for professionals and organizations ready to lead in the AI era.</em>
                </p>
            </div>

            {/* Scroll Hint */}
            <div className="absolute bottom-14 sm:bottom-6 left-1/2 -translate-x-1/2">
                <div className="flex flex-col items-center text-gray-400">
                    <p className="text-[10px] sm:text-xs tracking-[0.2em] uppercase mb-1 sm:mb-2">Discover programs</p>
                    <div className="w-px h-6 sm:h-8 bg-gray-400"></div>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
